module.exports = __webpack_public_path__ + "img/furnitureshop-grid-slider.eed8defc.png";